import React, { forwardRef } from 'react';
import classnames from 'classnames';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Typography_bold_3fRcElV9Xx{font-weight:700}.Typography_italic_33YM0mt0qS{font-style:italic}.Typography_h1_1Rh4YITxO9,.Typography_h2_bo4TW918l9,.Typography_h3_2Xx0YiRF87,.Typography_h4_1pZ-r2BD4N,.Typography_h5_3vH43LBiz-,.Typography_h6_2b-FktWoCF,.Typography_hero_clOM3Z3joL,.Typography_preHeading_Ff-1nhh8Gu{font-weight:500}.Typography_hero_clOM3Z3joL{font-size:2.5rem;line-height:3rem}.Typography_h1_1Rh4YITxO9,.Typography_hero_clOM3Z3joL{font-family:var(--font-family,\"Averta\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"sans-serif\");margin:0}.Typography_h1_1Rh4YITxO9{font-size:2rem;line-height:2.625rem}.Typography_h2_bo4TW918l9{font-family:var(--font-family,\"Averta\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"sans-serif\");font-size:1.5rem;line-height:2.25rem;margin:0}.Typography_h3_2Xx0YiRF87{line-height:1.875rem}.Typography_h3_2Xx0YiRF87,.Typography_h4_1pZ-r2BD4N{font-family:var(--font-family,\"Averta\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"sans-serif\");font-size:1.25rem;margin:0}.Typography_h4_1pZ-r2BD4N{line-height:1.75rem}.Typography_h5_3vH43LBiz-{font-size:1rem;line-height:1.5rem}.Typography_h5_3vH43LBiz-,.Typography_h6_2b-FktWoCF{font-family:var(--font-family,\"Averta\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"sans-serif\");margin:0}.Typography_h6_2b-FktWoCF{font-size:.875rem;line-height:1.375rem}.Typography_paragraph_1O4_21yY-F{font-size:1rem;line-height:1.5rem}.Typography_paragraph_1O4_21yY-F,.Typography_smallBodyContent_2ke7QBKnry{font-family:var(--font-family,\"Averta\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"sans-serif\");margin:0}.Typography_smallBodyContent_2ke7QBKnry{font-size:.75rem;line-height:1.125rem}.Typography_subheading_hZFIOdT-Du{line-height:1.75rem}.Typography_preHeading_Ff-1nhh8Gu,.Typography_subheading_hZFIOdT-Du,.Typography_tableHeader_2dDd0YckrI{font-family:var(--font-family,\"Averta\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"sans-serif\");font-size:1.125rem;margin:0}.Typography_preHeading_Ff-1nhh8Gu,.Typography_tableHeader_2dDd0YckrI{line-height:1.125rem;text-transform:uppercase}.Typography_defaultColor_3hzWrTphn2{color:var(--foreground,#2d2d2d)}.Typography_primaryColor_R575V_Xhae{color:var(--primary-base,#d54400)}.Typography_infoColor_3IkwDXhpWo{color:var(--info-base,#006fbb)}.Typography_successColor_13FZwLO-lN{color:var(--success-base,#218323)}.Typography_warningColor_3gMtObZIxQ{color:var(--warning-base,#ffc100)}.Typography_errorColor_2ls8FPWpFJ{color:var(--error-base,#d10f0f)}.Typography_metaColor_2nPmbZqxcI{color:var(--neutral-darker,#696c74)}.Typography_link_3xA7CHmwvg{display:inline-block;text-decoration:none;transition:box-shadow .1s ease-out;border-radius:3px;cursor:pointer;color:var(--secondary-base,#0a7c8e);position:relative;outline:none}.Typography_link_3xA7CHmwvg:active,.Typography_link_3xA7CHmwvg:hover{text-decoration:underline}.Typography_link_3xA7CHmwvg:visited{text-decoration:underline;color:var(--error-base,#d10f0f)}.Typography_link_3xA7CHmwvg:focus{box-shadow:0 0 0 4px var(--focus,rgba(96,150,230,.75))}@media screen and (min-width:768px){.Typography_hero_clOM3Z3joL{font-size:3rem;line-height:4.75rem}.Typography_h1_1Rh4YITxO9,.Typography_hero_clOM3Z3joL{font-family:var(--font-family,\"Averta\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"sans-serif\");margin:0}.Typography_h1_1Rh4YITxO9{font-size:2.5rem;line-height:3.75rem}.Typography_h2_bo4TW918l9{font-size:2rem;line-height:3rem}.Typography_h2_bo4TW918l9,.Typography_h3_2Xx0YiRF87{font-family:var(--font-family,\"Averta\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"sans-serif\");margin:0}.Typography_h3_2Xx0YiRF87{font-size:1.5rem;line-height:2.25rem}.Typography_h4_1pZ-r2BD4N{font-size:1.25rem;line-height:1.75rem}.Typography_h4_1pZ-r2BD4N,.Typography_h5_3vH43LBiz-{font-family:var(--font-family,\"Averta\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"sans-serif\");margin:0}.Typography_h5_3vH43LBiz-{font-size:1rem;line-height:1.5rem}.Typography_h6_2b-FktWoCF{font-family:var(--font-family,\"Averta\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",\"sans-serif\");font-size:.875rem;line-height:1.25rem;margin:0}}";
var styles = {"bold":"Typography_bold_3fRcElV9Xx","italic":"Typography_italic_33YM0mt0qS","hero":"Typography_hero_clOM3Z3joL","h1":"Typography_h1_1Rh4YITxO9","h2":"Typography_h2_bo4TW918l9","h3":"Typography_h3_2Xx0YiRF87","h4":"Typography_h4_1pZ-r2BD4N","h5":"Typography_h5_3vH43LBiz-","h6":"Typography_h6_2b-FktWoCF","preHeading":"Typography_preHeading_Ff-1nhh8Gu","paragraph":"Typography_paragraph_1O4_21yY-F","smallBodyContent":"Typography_smallBodyContent_2ke7QBKnry","subheading":"Typography_subheading_hZFIOdT-Du","tableHeader":"Typography_tableHeader_2dDd0YckrI","defaultColor":"Typography_defaultColor_3hzWrTphn2","primaryColor":"Typography_primaryColor_R575V_Xhae","infoColor":"Typography_infoColor_3IkwDXhpWo","successColor":"Typography_successColor_13FZwLO-lN","warningColor":"Typography_warningColor_3gMtObZIxQ","errorColor":"Typography_errorColor_2ls8FPWpFJ","metaColor":"Typography_metaColor_2nPmbZqxcI","link":"Typography_link_3xA7CHmwvg"};
styleInject(css_248z);

const Heading = forwardRef((props, ref) => {
    const { as, className = '', color = 'default', size } = props, rest = __rest(props, ["as", "className", "color", "size"]);
    const Component = as;
    const computedSize = size !== undefined ? `h${size}` : as;
    const classNames = classnames({
        [styles.hero]: computedSize === 'hhero',
        [styles.h1]: computedSize === 'h1',
        [styles.h2]: computedSize === 'h2',
        [styles.h3]: computedSize === 'h3',
        [styles.h4]: computedSize === 'h4',
        [styles.h5]: computedSize === 'h5',
        [styles.h6]: computedSize === 'h6',
        [styles.bold]: true,
        [styles[`${color}Color`]]: true,
        [className]: className,
    });
    return React.createElement(Component, Object.assign({}, rest, { className: classNames, ref: ref }));
});
Heading.displayName = 'Heading';

const Text = forwardRef((props, ref) => {
    const { as = 'p', color = 'default', size = 'body', bold, italic, className = '' } = props, rest = __rest(props, ["as", "color", "size", "bold", "italic", "className"]);
    const Component = as;
    const classNames = classnames({
        [styles.h1]: size === 1,
        [styles.h2]: size === 2,
        [styles.h3]: size === 3,
        [styles.h4]: size === 4,
        [styles.h5]: size === 5,
        [styles.h6]: size === 6,
        [styles.subheading]: size === 'subhead',
        [styles.paragraph]: size === 'body',
        [styles.smallBodyContent]: size === 'body-small',
        [styles.preHeading]: size === 'pre-heading',
        [styles.bold]: bold,
        [styles.italic]: italic,
        [styles[`${color}Color`]]: true,
        [className]: className,
    });
    return React.createElement(Component, Object.assign({}, rest, { className: classNames, ref: ref }));
});
Text.displayName = 'Text';

const Link = React.forwardRef((props, ref) => {
    const { as = 'a', className = '' } = props, rest = __rest(props, ["as", "className"]);
    const Component = as;
    const classNames = classnames({
        [styles.link]: true,
        [className]: className,
    });
    return React.createElement(Component, Object.assign({}, rest, { className: classNames, ref: ref }));
});
Link.displayName = 'Link';

export { Heading, Link, Text };
